import { render, staticRenderFns } from "./paomadeng.vue?vue&type=template&id=f00a69ee&scoped=true&"
import script from "./paomadeng.vue?vue&type=script&lang=js&"
export * from "./paomadeng.vue?vue&type=script&lang=js&"
import style0 from "./paomadeng.vue?vue&type=style&index=0&id=f00a69ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00a69ee",
  null
  
)

export default component.exports